import { Radio as FRadio } from '@forest/forms';
import { connect, mapProps } from '@formily/react';
export const Radio = connect(FRadio, mapProps({
    value: 'checked',
}));
Radio.Group = connect(FRadio.Group, mapProps({
    dataSource: 'options',
}));
export default Radio;
